export default "__VITE_ASSET__2eQesGCi__"